import React, { useState } from 'react';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
const InternalSlideCard = ({ img, title, title2 }) => {
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	return (
		<Grid container>
			<Grid
				item
				xs={12}
				sm={12}
				md={12}
				lg={12}
				style={{
					height: matches ? '28vh' : '50vh',
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					backgroundColor: 'yellow',
					backgroundImage: `url(${img})`,
					backgroundSize: 'cover',
					backgroundRepeat: 'no-repeat',
					backgroundPosition: 'center center',
					borderRadius: 5,
				}}></Grid>
		</Grid>
	);
};
export default InternalSlideCard;
